import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast, Toaster } from "sonner";
import api from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("mb_token", r.data.token);
      localStorage.setItem("mb_email", r.data.email);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center px-4 font-body">
      <Toaster position="top-right" richColors/>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#B84F3E] flex items-center justify-center text-white mx-auto mb-4">
            <Home className="w-7 h-7" strokeWidth={1.5}/>
          </div>
          <h1 className="font-serif text-4xl text-[#4A403B]">Megh Balika Admin</h1>
          <p className="text-[#8A7970] text-sm mt-2">Manage bookings, pricing, and guests</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-sm border border-[#E7C2A6]/40" data-testid="admin-login-form">
          <div className="mb-4">
            <label className="text-sm text-[#8A7970] mb-1.5 block">Email</label>
            <Input value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="admin@mbhomestay.in" data-testid="admin-email-input" required/>
          </div>
          <div className="mb-6">
            <label className="text-sm text-[#8A7970] mb-1.5 block">Password</label>
            <Input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="admin-password-input" required/>
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#B84F3E] hover:bg-[#9A3F30] text-white py-5" data-testid="admin-login-submit-btn">
            {busy ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
